function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 16.9167,
  r: 1.08333,
  fill: "#627080"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 12.5V5.5",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgHint2 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHint2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Hint-2.5691e4c8.svg";
export { ForwardRef as ReactComponent };